import React, { useEffect, useState } from "react";
import { Box, Text, Flex, Input, Image, useToast } from "@chakra-ui/react";
import Resizer from "react-image-file-resizer";
import fileUpload from "../../providers/fileUpload"
import c from "../../constant"
import UploadingModal from "../UploadingModal/UploadingModal"
import { useTranslation } from "react-i18next";

const ImagePicker = ({initContent={}, onContentChange}) => {
    const { t } = useTranslation();
    const toast = useToast()
    // const [original, setOriginal] = useState(initContent?.original);
    const [micro, setMicro] = useState(initContent?.micro?initContent?.micro:"");
    const [low, setLow] = useState(initContent?.low?initContent?.low:"");
    const [medium, setMedium] = useState(initContent?.medium?initContent?.medium:"");
    const [placeholder, setPlaceholder] = useState(initContent?.placeholder?initContent?.placeholder:"");
    const [fileName, setFileName] = useState(initContent?.fileName?initContent?.fileName:"");
    const [preview, setPreView] = useState(initContent?.medium?c.baseFilePath+initContent?.medium:"");

    const [loading, setLoading] = useState(false)
    const [error, serError] = useState(false)

    function errorMessage(type){
        toast({
            title: `Image type of ${type} failed to upload`,
            status: "error",
            position:"top-right",
            isClosable: true,
        })
    }

    useEffect(()=>{
        if(micro && low && medium && placeholder){
            const content = {
                placeholder,
                micro,
                low,
                medium,
                fileName,
            }
            onContentChange(content)
            setLoading(false)
        }
    },[micro, low, medium, placeholder, fileName])

    function fileChangedHandler(event) {
        setLoading(true)
        var fileInput = false;
        if (event.target.files[0]) {
            fileInput = true;
        }
        if (fileInput) {
            // fileUpload(event.target.files[0]).then(response=>{
            //     setOriginal(response);
            //     console.log("original:", response)
            // }).catch(()=>{
            //     errorMessage("original")
            // })
            try {
                Resizer.imageFileResizer(
                    event.target.files[0],
                    1080,
                    "auto",
                    "JPEG",
                    90,
                    0,
                    (uri) => {
                        setPreView(uri);
                    },
                    "base64"
                );
                Resizer.imageFileResizer(
                    event.target.files[0],
                    1080,
                    "auto",
                    "JPEG",
                    90,
                    0,
                    (uri) => {
                        fileUpload(uri).then(response=>{
                            setMedium(response);
                            console.log("Medium:", response)
                        }).catch(()=>{
                            serError(true)
                            errorMessage("medium")
                        })
                    },
                    "file"
                );
                Resizer.imageFileResizer(
                    event.target.files[0],
                    720,
                    "auto",
                    "JPEG",
                    90,
                    0,
                    (uri) => {
                        fileUpload(uri).then(response=>{
                            setLow(response);
                        }).catch(()=>{
                            errorMessage("low")
                            serError(true)
                        })
                    },
                    "file"
                );
                Resizer.imageFileResizer(
                    event.target.files[0],
                    200,
                    "auto",
                    "JPEG",
                    90,
                    0,
                    (uri) => {
                        fileUpload(uri).then(response=>{
                            setMicro(response);
                        }).catch(()=>{
                            errorMessage("micro")
                            serError(true)
                        })
                    },
                    "file"
                );
                Resizer.imageFileResizer(
                    event.target.files[0],
                    16,
                    "auto",
                    "JPEG",
                    90,
                    0,
                    (uri) => {
                        fileUpload(uri).then(response=>{
                            setPlaceholder(response);
                            console.log("placeholder:", response)
                        }).catch(()=>{
                            errorMessage("placeholder")
                            serError(true)
                        })
                    },
                    "file"
                );
            } catch (err) {
                console.log(err);
            }
        }
    }

    return (
        <>
            <Box bg="gray.200" p="4" mb="4" borderRadius={c.borderRadius}>
                <Text fontWeight="bold" mb="4">
                    {t("Please choose an Image file")}
                </Text>
                <input
                    id="file"
                    type="file"
                    accept="image/*"
                    onChange={fileChangedHandler}
                />
                <br />
                <Flex mt="4" alignItems="center">
                    <Text mr="2">{t("Enter File Name")}</Text>
                    <Input
                        bg="white"
                        w="200px"
                        id="file-name"
                        type="text"
                        value={fileName}
                        onChange={(e) => setFileName(e.target.value)}
                    />
                </Flex>
                <Image src={preview} w="100%" h="auto" mt="4" />
            </Box>
            <UploadingModal isOpen={(!error&&loading)}/>
        </>
    );
};

export default ImagePicker;
